<template>
  <div
    @click="handleClick"
  >
    <GoogleLogin
      class="google-login"
      :params="params"
      :on-success="handleSuccess"
      :on-failure="handleFailure"
    >
      <img
        src="@/assets/svg/google-icon.svg"
        class="w-20 inline"
        alt="Google logo"
      >
      Sign in with Google
    </GoogleLogin>
  </div>
</template>

<script>
import GoogleLogin from 'vue-google-login'
import DataLayer from '@/utilities/data-layer'
import navigation from '@/mixins/navigation'

export default {
  name: 'AppGoogleLogin',

  // Components
  components: {
    GoogleLogin
  },

  mixins: [
    navigation
  ],

  // Data
  data () {
    return {
      params: {
        client_id: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID
      }
    }
  },

  methods: {
    handleClick () {
      DataLayer.pushEvent('event', `spring_${this.eventPrefix}_google_button_clicked`)
    },

    handleSuccess (googleUser) {
      this.$emit('success', googleUser)
    },

    handleFailure (event) {
      this.$emit('failure', event)
    }
  }
}
</script>

<style scoped lang="scss">
.google-login {
  @apply bg-white transition w-full shadow-hover h-50;

  &:hover {
    @apply bg-gray-50;
  }
}
</style>
